import type { ReactElement, ReactNode } from 'react'
import type { IntlShape } from 'react-intl'
import type { PropertyCancellationLabelShape } from 'components/Common/CancellationPolicies/utils/getCancellationPolicyStatus'

interface Input {
  intl: IntlShape
  labelShape: Exclude<PropertyCancellationLabelShape, { kind: 'non-refundable' }>
  refundType: ReactElement
}

/** Format the existing date/status label without changing its date or hotel-only contract. */
export function getPropertyCancellationLabelText({ intl, labelShape, refundType }: Input): ReactNode {
  if (labelShape.kind === 'date' && labelShape.hotelOnly) {
    return intl.formatMessage(
      {
        id: 'nsXp9-TaxkcfoC_Mgmn8',
        defaultMessage: '{refundType} until {date} (hotel only)',
        description: 'Cancellation policy with date and hotel-only clarification',
      },
      { refundType, date: labelShape.formattedDate },
    )
  }
  if (labelShape.kind === 'date') {
    return intl.formatMessage(
      {
        id: 'nGO52oYKVABrD8dlQrKg',
        defaultMessage: '{refundType} until {date}',
        description: 'Cancellation policy with deadline date in the date selection or calendar picker',
      },
      { refundType, date: labelShape.formattedDate },
    )
  }
  if (labelShape.hotelOnly) {
    return intl.formatMessage({
      id: 'TU9nLufGKPNHd7PoClqw',
      defaultMessage: '{refundType} (hotel only)',
      description: 'Accommodation cancellation status without a headline date when another travel product is selected',
    }, { refundType })
  }
  return refundType
}
